import {AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {NavigationService} from '~/app/core/navigation.service';
import {ActivatedRoute} from '@angular/router';
import {CoreService} from '~/app/core/core.service';
import {OfferInfo} from '~/app/core/model/offer-info';
import {BasePage} from '~/app/pages/base.page';
import {LocationInfo} from '~/app/core/model/location-info';
import {RedeemDialogComponent} from '~/app/pages/offer/redeemDialog.component';
import {AddressInfo} from '~/app/core/model/address-info';
import {CongratulationsDialogComponent} from '~/app/pages/offer/congratulationsDialog.component';
import {ModalType} from '~/app/core/modal.service';
import {OfferService} from '~/app/core/offer-service/offer.service';
import {UserInfo} from '~/app/core/model/user-info';
import {UserProfileService} from '~/app/core/user-profile-service/user-profile.service';
import {CreateAccountDialogComponent} from '~/app/pages/offer/createAccountDialog.component';
import {ApiService} from "~/app/core/api.service";
import {TicketService} from "~/app/core/model/ticket-service/ticket.service";
import {InteractionService} from "~/app/core/interaction.service";
import {InteractionOffer} from "~/app/core/model/interaction/interaction-offer";
import {Title} from "@angular/platform-browser";

@Component({
    selector: 'Offer',
    templateUrl: './offer.page.html',
    styleUrls: ['./offer.page.scss'],
})
export class OfferPage extends BasePage implements OnInit, AfterViewInit {
  backColor = '#BB0F23';
  textColor = 'white';
  offer: OfferInfo;
  @ViewChild('offerImageContainer') offerImageContainer: ElementRef;
  distance: number = null;
  longitude: number = null;
  latitude: number = null;
  findingLocation = false;
  nearestAddress: AddressInfo = null;
  userInfo: UserInfo;

  constructor(
      private readonly cd: ChangeDetectorRef,
      private readonly nav: NavigationService,
      private readonly route: ActivatedRoute,
      private readonly core: CoreService,
      private readonly offerService: OfferService,
      private readonly userProfileService: UserProfileService,
      private readonly interactionService: InteractionService,
      private readonly title: Title,
  ) {
    super();
  }

  ngOnInit() {
    this.userInfo = this.userProfileService.userInfo;
    this.loadOffer();
    if (!this.core.storage.loadCode()) {
      const search = location.search.substring(1);
      const referralCode = search.replace('referral_code=', '');
      if (referralCode.trim().length >= 1) {
        this.core.storage.storeCode(referralCode);
      }
    }
  }

  // resize div to fit image
  ngAfterViewInit() {
    this.reScaleImage(this.offerImageContainer.nativeElement);
  }

  private reScaleImage(container) {
    const image = new Image();
    image.src = container.style.backgroundImage.replace(/url\((['"])?(.*?)\1\)/gi, '$2').split(',')[0];
    image.onload = function() {
      const width = image.width;
      const height = image.height;
      const cwidth = document.documentElement.offsetWidth;
      const newHeight = Math.floor((cwidth / width) * height);
      container.style.height = newHeight + 'px';
    };
  }

  public getCity(offerInfo: OfferInfo) {
    if (this.nearestAddress != null) {
      return this.nearestAddress.city + ' ' + this.distance + 'mi';
    }
    else if (offerInfo.addresses != null && offerInfo.addresses.length > 0) {
      return offerInfo.addresses[0].city;
    }
  }

  public setFavorite() {
    this.offerService.favoriteOffer(this.offer.id);
    this.offer.favorite = true;
    console.log('TODO update \'My Favorites\' list');
  }
  public goBack() {
    this.nav.navBack();
  }
  public unsetFavorite() {
    this.offerService.unfavoriteOffer(this.offer.id);
    this.offer.favorite = false;
  }

  private loadOffer() {
    // TODO refactor to access the OfferInfo object from HomeComponent instead of creating a new OfferInfo object
    const offerId = this.route.snapshot.paramMap.get('offerId');
    this.offer = this.core.api.offers_getOffer(Number(offerId));
    if (this.offer == null) {
      // this happens if you try to load an offer directly in a browser without going through the app.
      // we need to look up the offer and save in local storage.
      console.log("offer " + offerId  + " not found in local storage");
      // this.core.api.offers_performSearch();
      this.core.api.offers_getOfferViaApi(Number(offerId)).then(offer => {
        this.offer = offer;
      });
    }
    console.log("loadOffer:");
    console.log(this.offer);

    let data: InteractionOffer = {
      pgOpenCount: 1,
      pgViewCount: 1
    };
    this.interactionService.interactOffer(Number(offerId), data);

    this.findNearestLocation();
    this.title.setTitle(this.offer.name);
  }

  async showRedeemDialog() {
    class RedeemData {
      data: number;
      role: any;
    }
    const modalType: ModalType = this.offer.onlineOnly ? 'sheet-quarter' : 'sheet-half';
    const modal = await this.core.modal.create({component: RedeemDialogComponent, componentProps: { offerId: this.offer.id, offer: this.offer }}, modalType, 'normal');
    modal.onDidDismiss().then((redeemData: RedeemData) => {
      if (redeemData.data) {
        this.offer.redeemedDate = new Date().toISOString();
        console.log('User redeemed offer ' + redeemData.data);
        this.showPurchasedDialog();
      }
    });
  }

  async showCreateAccountDialog() {
    const modalType: ModalType = 'sheet-half';
    const modal = await this.core.modal.create({component: CreateAccountDialogComponent, componentProps: {offerId: this.offer.id, offer: this.offer}}, modalType, 'normal');
  }

  async showPurchasedDialog() {
    class Data {
      data: boolean;
    }
    const modal = await this.core.modal.create({
      component: CongratulationsDialogComponent,
      componentProps: {offer: this.offer}
    }, 'sheet-half', 'normal');
    modal.onDidDismiss().then((yesNo: Data) => {
        console.log('User purchased something? ' + yesNo.data);
    });
  }


  private cleanupUrl(url) {
    return url.replace(/(^\w+:|^)\/\//, '').replace(/\/$/, '');
  }

  calculateDistance(address: AddressInfo): number {
    const distance = this.milesAwayPrecise(address);
    if (distance) {
      return distance > 1 ? Math.round(distance) : Math.round(distance * 10) / 10;
    }
    return null;
  }

  milesAwayPrecise(address: AddressInfo): number {
    if (this.hasMilesAway(address)) {
      const distance = LocationInfo.milesAway(
        { longitude: address.longitude, latitude: address.latitude },
        { longitude: this.longitude, latitude: this.latitude }
      );
      return distance;
    }
    return null;
  }

  hasMilesAway(address: AddressInfo): boolean {
    return !!address.latitude && !!address.longitude && !!this.longitude && !!this.latitude;
  }

  findNearestLocation() {
    this.findingLocation = true;
    this.core.api.location_getLocationInfo().then(locationInfo => {
      this.longitude = locationInfo.longitude;
      this.latitude = locationInfo.latitude;
      this.findingLocation = false;
      for (const address of this.offer.addresses) {
        const calculatedDistance = this.calculateDistance(address);
        if (this.distance == null || calculatedDistance < this.distance) {
          this.distance = calculatedDistance;
          this.nearestAddress = address;
        }
      }
    }, (error) => {
      console.log('Error getting location');
      this.findingLocation = false;
    });
  }

  getMapUrl(address: AddressInfo) {
    let urlScheme = 'maps';
    if /* if we're on iOS, open in Apple Maps */
    ((navigator.platform.indexOf('iPhone') != -1) || (navigator.platform.indexOf('iPad') != -1) || (navigator.platform.indexOf('iPod') != -1))
      {urlScheme = 'maps';}
    else
      {urlScheme = 'https';}
    // return urlScheme + "://maps.google.com/maps?daddr="+this.nearestAddress.latitude+","+this.nearestAddress.longitude+"&amp;ll=";
    return urlScheme + '://maps.google.com/maps/dir/'+this.latitude+','+this.longitude+'/'+address.latitude+','+address.longitude;
  }

  showMap(address: AddressInfo) {
    window.open(this.getMapUrl(address), '_blank');
  }

  shareFunction() {
    this.userProfileService.getUserReferralCode().then((code) => {
      const url = window.location.href.split('?')[0] + '?referral_code=' + code;
      if (navigator.share) {
        navigator.share({
          title: document.title,
          text: 'Hello World',
          url,
        })
          .then(() => console.log('Successful share'))
          .catch(error => console.log('Error sharing:', error));
      } else {
        navigator.clipboard.writeText(url);
        this.core.toast.toastSuccess({
            header: "Copy success",
            message: "Copied to clipboard",
            onHide: () => {}
          });
      }
    });
  }
}
